import { Transform } from 'stream';
import { initId } from '@/renderer/scripts/utils/tools';

/**
 * 自定义限速流
 * @description 限速流既可以实现限速，也可以实现测速功能。
 * @description 注意，限速流只实现了read的限速
 * readStream.pipe(new LimitStream).pipe(axios)
 * axios.pipe(new LimitStream).pipe(writeStream)
 */
export default class LimitStream extends Transform {
  id: string;
  // 每次传输的bytes
  sentBytes = 0;
  // 每次传输的开始时间
  startTime: number;
  // 限速值
  limit: number | null = null;
  /**
   * 传入一个可读/可写流
   * @description 限速的方式其实是
   * 使用记速器进行计算，
   * 若超速，则使用stream.pause()进行暂停
   * 随后 xxms之后stream.resume()恢复
   * 由于暂停和恢复进行的恰到好处，而且都是ms级别，所以宏观上看上去是被限速了
   */
  constructor() {
    super();
    this.id = initId('limitStream');
    this.startTime = Date.now();
  }

  /**
   * 设置Limit限速
   * @param limit 单位b/s 例如：200kb/s则传递200
   */
  setLimit(limit: number) {
    this.limit = (limit * 1024) / 1000.0; // converts to bytes per ms
  }
  // 重置Limit速度为null
  reSetLimit() {
    this.limit = null;
  }

  /**
   * transform 方法实现了接受写入的字节，计算输出，随后使用this.push()来吧输出传输到可读内存中
   * @description 等效的  callback(null,chunk)
   * @param chunk
   * @param encoding
   * @param callback callback的第一个参数必须是ERROR对象，否则为null 如果传递了第二个参数，则callback会被转发到transform.push()
   * @private
   */
  _transform(chunk: any, encoding: BufferEncoding, callback: (error?: Error | null, data?: any) => void) {
    this.push(chunk, encoding);
    this.sentBytes += chunk.length;
    if (this.limit) {
      this._limit(chunk, encoding, callback);
    } else {
      callback();
    }
  }

  /**
   * 限速方法
   * @description
   * 必须有limit才可进入本方法，否则报错
   * @param chunk
   * @param encoding
   * @param callback
   */
  _limit(chunk: any, encoding: BufferEncoding, callback: (error?: Error | null, data?: any) => void) {
    if (!this.limit) {
      callback();
      return;
    }
    try {
      const now = Date.now();
      //  流逝的时间
      const elapsedTime = now - Number(this.startTime);
      // 消耗掉chunk数据所需要的时间
      const assumedTime = this.sentBytes / this.limit;
      // 需要让当前流延后的时间
      let lag = assumedTime - elapsedTime;
      if (lag > 10 * 1000) {
        lag = 10 * 1000;
      }
      // 若延后时间大于0，则代表超速了，需要延后
      if (lag > 0) {
        setTimeout(() => callback(null), lag);
      } else {
        callback(null);
      }
    } catch (e) {
      callback(e);
    }
  }
}
